// extracted by mini-css-extract-plugin
module.exports = {"banner":"company-announcement_banner__WrfDt","bannerLink":"company-announcement_bannerLink__0c7La","bannerButton":"company-announcement_bannerButton__cfdtY"};